module.exports = __webpack_public_path__ + "images/117bd98db1a97317265c08ae04642e6c.gif";